<template v-if="false">
  <section id="Quiz">
    <div class="flex-center mt-4 mb-2 cyan darken-3">
      <img class="p-2 mb-0" height="80px" alt="Logo" src="../assets/5.png" />
    </div>
      <card class="mt-0">
        <card-body>
            <card-text>
            <p><b>Уважаемые клиенты! Уделите, пожалуйста, 5 минут Вашего времени на заполнение анкеты, и мы подарим Вам скидку 5% на новую заказную позицию СЕТ.</b></p>
            <!-- <p><b>Просьба заполнить анкету до 30 июня включительно.</b></p> -->
          </card-text>
        </card-body>
      </card>
      <card class="mt-2 input-group">
        <card-header>Сфера Вашего бизнеса</card-header>
        <card-body>
        <card-text>
            <div class="form-group">
              <select v-model="sfera" class="browser-default custom-select">
                <option v-for="(sfera, index) in sferas" :key="index" :value="sfera">{{ sfera }}</option>
              </select>
            </div>
          </card-text>
        </card-body>
      </card>

        <card v-if="sfera === 'Сервис' || sfera === 'Сервис и продажи'" class="mt-2 p-1 input-group">
        <card-header>Какой парк печатного оборудования Вы обслуживаете?</card-header>

        <card-body>
          <card-text>
                 <div class="row">
              <div class="col-md-6" v-for="(brand, index) in brands" :key="index">
                <div class="custom-control custom-checkbox">
                  <input v-model="park[index]" type="checkbox" class="custom-control-input" :id="index">
                  <label class="custom-control-label" :for="index">{{ brand }}</label>
                </div>
              </div>
            </div>
          </card-text>
          </card-body>

      </card>

      <card class="mt-1 p-1 input-group">
        <card-header>С какими брендами печатного оборудования возникают сложности (из-за недостающих деталей)?</card-header>
            <card-body>
              <card-text>
            <div class="row">
              <div class="col-md-6" v-for="(brand3, index3) in brands" :key="'tr' + index3">
                <div class="custom-control custom-checkbox">
                  <input v-model="troubles[index3]" type="checkbox" class="custom-control-input" :id="100 + index3">
                  <label class="custom-control-label" :for="100 + index3">{{ brand3 }}</label>
                </div>
              </div>
            </div>
          </card-text>
          </card-body>
      </card>

        <card class="mt-1 p-1 input-group">
          <card-header>Укажите самые актуальные модели аппаратов, на которые сложно найти запчасть.</card-header>
            <card-body>
              <card-text>
            <input v-model="hard" type="textarea" id="example1" class="form-control">
              </card-text>
            </card-body>

        </card>

        <card class="mt-1 p-1 input-group">
          <card-header>Покупаете ли Вы продукцию СЕТ у других поставщиков? Если да, то по какой причине.</card-header>
              <card-body>
                <card-text>
                <select v-model="concurent" class="browser-default custom-select">
                  <option v-for="(conc, index) in concurents" :value="conc" :key="index">{{ conc }}</option>
                </select>
              </card-text>
              </card-body>
          </card>

          <card class="mt-1 p-1 input-group">
            <card-header>Какую продукцию стоит добавить в наш ассортимент?</card-header>
             <card-body>
              <card-text>
              <input v-model="add" type="textarea" id="example1" class="form-control">
            </card-text>
            </card-body>
         </card>

         <card class="mt-1 p-1 input-group">
          <card-header>Откуда узнаете о новинках и акциях нашей компании?</card-header>
             <card-body>
              <card-text>
              <div v-for="(channel, index2) in channels" :key="index2">
                <div class="custom-control custom-checkbox">
                  <input v-model="news[index2]" type="checkbox" class="custom-control-input" :id="channel">
                  <label class="custom-control-label" :for="channel">{{ channel }}</label>
                </div>
              </div>
              Другое: <input v-model="altnews" type="textarea" id="altnews" class="form-control">
            </card-text>
            </card-body>
          </card>

      <row class="row">
        <column class="d-flex justify-content-center mt-5 align-self-center animated slow zoomIn" md="12">

          <template>

            <div>
              <btn class="cyan text-white hoverable" @click.native="QuizResult()">Отправить результаты</btn>
            </div>
          </template>

        </column>
      </row>

  </section>
</template>

<script>

import { Row, Column, Btn, Card, CardBody, CardHeader, CardText } from 'mdbvue'
import ApiService from '@/services/ApiService'
import router from '@/router'

export default {
  name: 'Quiz',
  components: {
    Row,
    Column,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText
  },
  data () {
    return {
      add: '',
      company: '',
      sfera: '',
      hard: '',
      concurent: '',
      sferas: [
        'Сервис',
        'Продажи',
        'Сервис и продажи'
      ],
      concurents: [
        'Нет, берем только у вас',
        'Да, покупаем у других (ниже цена)',
        'Да, покупаем у других (шире ассортимент)',
        'Не продаем / не используем продукцию СЕТ'
      ],
      brands: [
        'Brother',
        'Canon',
        'HP',
        'Konica Minolta',
        'Kyocera Mita',
        'OKI',
        'Ricoh',
        'Samsung',
        'Xerox',
        'Epson',
        'Lexmark',
        'Pantum',
        'Sharp',
        'Triumph-Adler'],
      channels: [
        'Рассылки',
        'Сайт',
        'Telegram',
        'От менеджера'

      ],
      park: [],
      troubles: [],
      news: [],
      altnews: '',
      quiz: []
    }
  },
  methods: {
    async QuizResult () {
      this.quiz = []
      this.quiz.push({ key: 'id', value: this.$route.query.id })
      this.quiz.push({ key: 'c', value: this.$route.query.с })
      // this.quiz.push({ key: 'Компания', value: this.company })
      this.quiz.push({ key: 'Сфера', value: this.sfera })
      this.park.forEach((item, index) => {
        if (item === true) {
          this.quiz.push({ key: 'Парк', value: this.brands[index] })
        }
      })

      this.troubles.forEach((item, index) => {
        if (item === true) {
          this.quiz.push({ key: 'ТрудноНайтиЗапчасти', value: this.brands[index] })
        }
      })

      this.quiz.push({ key: 'ТрудноНайти', value: this.hard })
      this.quiz.push({ key: 'Конкуренты', value: this.concurent })
      this.quiz.push({ key: 'ЧтоДобавить', value: this.add })

      this.news.forEach((item, index) => {
        if (item === true) {
          this.quiz.push({ key: 'Новости', value: this.channels[index] })
        }
      })
      this.quiz.push({ key: 'АльтНовости', value: this.altnews })
      var file = JSON.stringify(this.quiz)
      var res = await ApiService.writeQuiz(this.$route.query.id, file)
      console.log('Результаты опроса ', this.quiz)
      console.log('Ответ сервера ', res)
      this.$dialog.alert('Ваше сообщение успешно отправлено.<br> Спасибо за уделённое время!').then(function (dialog) {
        router.push('/')
      })
    }
  },
  mounted () {
    // console.log(this.$route)
    // console.log(this.$route.query.id)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.full {
  height: 100vh;
}

.bad-gateway-row {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 55%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.blockquote {
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Quiz.vue